/**
 * BM-7639 — Column Calculation slot for a single column header. Renders the kebab popover
 * trigger and stacked total pills, but only for Manual + Number columns. Other column types
 * render nothing so callers can drop this in unconditionally.
 */

import React from 'react';
import ColumnCalculationPopOver from './ColumnCalculationPopOver';
import ColumnTotalsDisplay from './ColumnTotalsDisplay';
import './ColumnCalculation.css';

/** True when the column is a manual Number column eligible for totals. */
const isManualNumber = (column) =>
  column && column.columnType === 'manual' && column.type === 'Number';

/** Header slot that renders the column-totals popover for Manual Number columns. */
function ColumnCalculation({ column, rangeplanId, userId, filters }) {
  if (!isManualNumber(column)) return null;

  return (
    <ColumnCalculationPopOver
      columnId={String(column._id)}
      rangeplanId={rangeplanId}
      userId={userId}
      filters={filters}
    />
  );
}

export { ColumnCalculationPopOver, ColumnTotalsDisplay, isManualNumber };
export default ColumnCalculation;
